export const TEXT_EDITOR_EVENTS = {
  ACTIVATE_EDIT: 'Activated Edit Text',
  DEACTIVATE_EDIT: 'Deactivated Edit Text',
  RESET: 'Reset Edited Text',
}